import requiredError from 'components/@home/@settings/Tabs/requiredError';
import { withFormik } from 'formik';
import { I18n } from 'utils/i18n';
import * as Yup from 'yup';

class FormSubmit {
  constructor(values, formikBag) {
    this.formikBag = formikBag;
    this.values = values;
  }

  assembleForm = () => {
    const {
      values: { name, options },
    } = this;

    const newOptions = options
      .filter(o => o.name)
      .map(o => {
        const no = { ...o };
        if (no._id.includes('.')) {
          delete no._id;
        }
        return no;
      });
    return { name, options: newOptions };
  };

  sendRequest = async form => {
    let ret;
    const { entityType: { _id } = { _id: 'new' }, actions } = this.formikBag.props;
    if (_id === 'new') {
      const newForm = { ...form };
      delete newForm._id;
      ret = await actions.chatFlowEntityTypes.create(newForm);
      actions.chatFlows.load();
    } else {
      ret = await actions.chatFlowEntityTypes.update(_id, form);
      actions.chatFlows.load();
    }
    ret = await actions.chatFlowEntityTypes.find(ret.value._id);
    return ret.value;
  };

  displayErrors = () => {
    const { setErrors } = this.formikBag;
    setErrors({ server: I18n.t('Something went wrong with sending data') });
  };
}

const chatFlowEntityTypeFormik = withFormik({
  enableReinitialize: true,
  validateOnChange: true,
  validationSchema: Yup.object().shape({
    name: Yup.string()
      .required(requiredError('name'))
      .matches(/^[_a-z][a-z0-9_]*$/i, () => I18n.t('ChatFlowSettings.errors.Variable name')),
    options: Yup.array().min(2, requiredError('options')),
  }),
  validate: values => {
    const errors = {};
    values.options.forEach((o, idx) => {
      if (o.name && o.texts.length < 1) {
        errors[`options.${idx}.texts`] = requiredError('texts');
      }
    });
    return errors;
  },
  mapPropsToValues: ({ entityType }) => {
    const options = entityType?.options || [];
    options.push({ _id: `${Math.random()}`, name: '', texts: [] });
    return {
      _id: entityType?._id || 'new',
      name: entityType?.name || '',
      options,
    };
  },
  handleSubmit: async (values, formikBag) => {
    const {
      props: { context },
      setSubmitting,
      resetForm,
    } = formikBag;

    const handler = new FormSubmit(values, formikBag);
    const form = handler.assembleForm();

    try {
      const ret = await handler.sendRequest(form);
      if (context.current.callback) {
        context.current.callback(ret);
      }
      context.pop();
      resetForm();
    } catch (err) {
      setSubmitting(false);
      handler.displayErrors(err);
    }
    return true;
  },
});

export default chatFlowEntityTypeFormik;
